import React, { useState } from 'react';

import Imports from 'bundles/crm/imports/components/imports';
import ImportSettings from './import_settings';
import Modal from 'components/modal';
import { compGroupIds } from './config';
import { usePollingImports } from 'components/dromo/hooks';

import type { CustomField } from 'bundles/apex/custom_fields/types';
import type { DromoImporterProps } from 'components/dromo/types';

interface Props {
  customFields: CustomField[];
  dromoImporterProps: DromoImporterProps;
  show?: boolean;
  onHide: (refresh: boolean) => void;
}

export default function CompsImports({
  customFields,
  dromoImporterProps,
  show,
  onHide,
}: Props) {
  const [imports, addImport] = usePollingImports(compGroupIds, show);
  const [currentStep, setCurrentStep] = useState(0);
  const [hasImported, setHasImported] = useState(false);

  const handleImport = (newImport) => {
    addImport(newImport);
    setHasImported(true);
    setCurrentStep(0);
  };

  const nextStep = () => setCurrentStep(prev => prev + 1);

  const steps = [
    <Imports imports={imports} key="comp-import-1" onClick={nextStep} />,
    <ImportSettings
      addImport={handleImport}
      customFields={customFields}
      dromoImporterProps={dromoImporterProps}
      key="comp-import-2"
      onHide={() => onHide(hasImported)}
    />,
  ];

  const reset = () => {
    setCurrentStep(0);
    setHasImported(false);
  };

  return (
    <Modal bsSize="large" show={show} onHide={() => onHide(hasImported)} onShow={reset}>
      <Modal.Header closeButton>Import Comps</Modal.Header>
      {steps[currentStep]}
    </Modal>
  );
}
